import {
  startOfWeek,
  addDays,
  format,
  formatISO,
  minutesToHours,
} from 'date-fns';

export const minsToHours = (value) => {
  const hours = minutesToHours(value);
  const minutes = value - hours * 60;

  return { hours, minutes };
};

export const createTimeText = (timeSpent) => {
  const { minutes, hours } = minsToHours(timeSpent);

  const hoursText = hours ? `${hours} h ` : '';

  let minsText = '';
  if (minutes) minsText = `${minutes} min`;
  else minsText = hours ? '' : '< 1 min';

  const summary = `${hoursText}${minsText}`;

  return summary;
};

export const getISOWeekDays = (date) => {
  const start = startOfWeek(date, { weekStartsOn: 1 });
  return [...Array(7).keys()].map((i) => {
    const day = addDays(start, i);
    const ISOday = formatISO(day).substring(0, 10);
    const abbr = format(day, 'ccccc', { weekStartsOn: 1 });
    return { day: ISOday, abbr };
  });
};

export const isInViewport = (element) => {
  const rect = element.getBoundingClientRect();
  const html = document.documentElement;
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <= (window.innerHeight || html.clientHeight) &&
    rect.right <= (window.innerWidth || html.clientWidth)
  );
};

export const statusColorsMap = new Map([
  [
    'not_started',
    {
      color: '#F34456',
      fill: 100,
      title: 'not started',
    },
  ],
  [
    'started',
    {
      color: '#FFC500',
      fill: 0,
      title: 'started',
    },
  ],
  [
    '1/4_completed',
    {
      color: '#FFC500',
      fill: 25,
      title: 'completed 1/4',
    },
  ],
  [
    'half_completed',
    {
      color: '#FFC500',
      fill: 50,
      title: 'completed half',
    },
  ],
  [
    '3/4_completed',
    {
      color: '#FFC500',
      fill: 75,
      title: 'completed 3/4 ',
    },
  ],
  [
    'completed',
    {
      color: '#6BAE46',
      fill: 100,
      title: 'completed',
    },
  ],
]);

export const statusArr = [...statusColorsMap.keys()];

export const Grades = [
  'Pre-kindergarten',
  'Kindergarten',
  'Grade 1',
  'Grade 2',
  'Grade 3',
  'Grade 4',
  'Grade 5',
];

export const GradesWithGrade6 = [...Grades, 'Grade 6'];
export const GradesAndTBD = [...Grades, 'Grade level TBD'];
export default getISOWeekDays;
